import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { YM_HIDE_CONTENT } from '@/shared/constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'NameOutput',
  props: {
    input: null,
    type: {
      default: 'short'
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    function getNameWithInitials(mainPart) {
      for (var _len = arguments.length, secondaryParts = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        secondaryParts[_key - 1] = arguments[_key];
      }
      return mainPart + secondaryParts.reduce(function (acc, val) {
        return val ? "".concat(acc, " ").concat(val.charAt(0), ".") : acc;
      }, '');
    }
    var output = computed(function () {
      var _props$input;
      var _ref = (_props$input = props.input) !== null && _props$input !== void 0 ? _props$input : {},
        surname = _ref.surname,
        name = _ref.name,
        patronymic = _ref.patronymic;
      if (!surname && !name && !patronymic) {
        return props.empty;
      }
      if (props.type === 'full') {
        return [surname, name, patronymic].filter(function (item) {
          return item;
        }).join(' ');
      }
      if (surname && name) {
        return getNameWithInitials(surname, name, patronymic);
      }
      return surname || name || patronymic;
    });
    return {
      __sfc: true,
      props: props,
      getNameWithInitials: getNameWithInitials,
      output: output,
      YM_HIDE_CONTENT: YM_HIDE_CONTENT
    };
  }
});